import {TMeta} from '../../machines/appMachine/AppContext';
import {useMeta} from '../MachineProvider/useMeta';

export const useGetContainerShow = () => {
  const meta = useMeta<TMeta>();
  return meta.show;
};
